import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { tcmHubConfigDetails } from '../../../config';
import { SharedService } from '../../../shared/services/shared.service';
import { AuthService } from '../auth.service';
import { Cookie } from 'ng2-cookies';
import { SharedAuthService } from '../../../shared/shared.auth.service';

@Component({
    selector: 'login-stub',
    templateUrl: './login-stub.component.html',
    styleUrls: ['./login-stub.component.less'],
    standalone: false
})
export class LoginStubComponent implements OnInit {
  model: any = {};
  loading = false;
  public nodeEndUrl = tcmHubConfigDetails.envApiUrl; // "http://localhost:1337";
  user: any = {};
  code: string;
  isInternalAccess = false;
  public sso: any;
  public tempUser: any;
  public token: any;

  public layer7at: string;
  private accessToken: any;
  public loader = false;
  public isIE: boolean;
  public isEdge: boolean;
  showSpinner: boolean = false;
  currentDateinMs: any;
  uniqueSessionId: any;
  loginSessionVar: any;
  public self: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private sharedService: SharedService,
    private auth: AuthService,
    private sharedAuthService: SharedAuthService
  ) {
  }

  ngOnInit() {

    this.isIE = window.navigator.userAgent.indexOf('Trident') > -1;
    this.isEdge = window.navigator.userAgent.indexOf('Edge') > -1;
    const rememberData = JSON.parse(sessionStorage.getItem('remember'));
    if (rememberData) {
      this.model = rememberData;
    }
  }
  logout() {
    sessionStorage.removeItem('currentUser');
  }

  login() {
    this.loader = true;
    this.self = this;

    /*  ************ CODE **************/

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: '*/*'
      })
    };
    if (this.model.remember) {
      sessionStorage.setItem('remember', JSON.stringify(this.model));
    }
    const loggedInUsername = this.model.username;
    return this.http
      .post<any>(
        this.self.nodeEndUrl + '/auth/login',
        JSON.stringify({
          Username: this.model.username,
          Password:  this.model.password,
        }),
        httpOptions
      )
      .toPromise()
      .then((response) => {
        let sn = response.sn;
        let givenName = response.givenName;
        let middleName = response.middleName;
        if (!sn) {
          sn = '';
        }
        if (!givenName) {
          givenName = '';
        }
        if (!middleName) {
          middleName = '';
        }
        sessionStorage.setItem('currentUser', JSON.stringify(sn + ', ' + givenName + ' ' + middleName));
        sessionStorage.setItem('loggedInUserEmail', JSON.stringify(response.mail));
        const appJwt = JSON.stringify(response.token).slice(1, -1);
        sessionStorage.setItem('token', appJwt);
        sessionStorage.setItem('currentUser', JSON.stringify(sn + ', ' + givenName + ' ' + middleName));
        sessionStorage.setItem('loggedInUserEmail', JSON.stringify(response.mail));
        sessionStorage.setItem('token', appJwt);
        // Scope app JWT cookie to media routes only (video/thumb/etc.) so it isn't sent with other APIs.
        this.sharedAuthService.setMediaTokenCookie(appJwt);
        const currentDate = new Date();
        this.currentDateinMs = new Date();
        this.uniqueSessionId = loggedInUsername + currentDate.toString().replace(/ /g, '');
        const MsId = loggedInUsername;
        sessionStorage.setItem('MsId', MsId);
        sessionStorage.setItem('MsId', MsId);
      
      })
      .then((data) => {
        this.loginSessionVar = data;
        this.updateUserStats(loggedInUsername);
        sessionStorage.setItem('selectedApp', 'All');
        sessionStorage.setItem('selectedLob', 'All');
      })
      .catch((data) => {
        this.self.loader = false;
        if (data.status === 401 && data.error && data.error.message === 'Restricted Access') {
          this.self.router.navigate([{ outlets: { primary: 'error-NotPartSecure' } }]);
        } else {
          alert('Error occured while logging. Please check your login details.');
        }
      });
  }

  updateUserStats(msId: string) {
    const body = {
      logIn_at: new Date().toISOString(),
      email: JSON.parse(sessionStorage.getItem('loggedInUserEmail')),
      name: JSON.parse(sessionStorage.getItem('currentUser')),

    };
    this.sharedService.createUserStats(msId, body).subscribe(() => {
    });
  }
}